import { FC, memo, useState } from 'react'
import styled from 'styled-components'

import Mascot_hello from '../consts/Mascot_Hello.json'
import Mascot_ball from '../consts/Mascot_ball.json'
import Mascot_bank from '../consts/Mascot_Bank.json'
import Mascot_map from '../consts/Mascot_Map.json'
import Mascot_trrophy from '../consts/Mascot_Trrophy.json'

import Lottie from 'lottie-react'
import MainButton from './UIKit/MainButton';
import Modal from './UIKit/Modal';
import { MAIN_COLORS } from '../consts/colors';

interface IProps{
  visible:boolean;
  close:()=>void
}

const MainWrapper = styled.div`
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
`
const Card = styled.div`
  background: ${MAIN_COLORS.gradient_purple_200};
  border-radius: 12px;
  padding: 0 16px;
  gap:24px;
  overflow: hidden;
`
const SliderWrapper = styled.div`
  width: 100%;
  height: 100%;
  overflow: hidden;
  position: relative;
`;
const SliderInner = styled.div<{ index: number }>`
  display: flex;
  height: 100%;
  transition: transform 0.4s ease-in-out;
  transform: ${({ index }) => `translateX(-${index * 100}%)`};
`;

const Slide = styled.div`
  width: 100%;
  padding: 20px;
  text-align: center;
  flex-shrink: 0;
  color: #ffffff;

  .anim{
    width:90vw;
    height:46vh;
    svg {
      transform: translate(-10%, 0%) !important;
    }
  }
`;
const Rare = styled.div`
  width: 60%;
  height: 30%;
  border-radius: 50%;
  opacity: 0.8;
  background: ${MAIN_COLORS.gradient_yellow_pink};
  filter: blur(21px);
  position: absolute;
  top: 20%;
  left: 20%;
`
const Indicators = styled.div`
  display: flex;
  padding: 10px 0;
  justify-content: center;
  gap: 10px;
`;
const Dot = styled.div<{ active: boolean }>`
  width: 12px;
  height: 12px;
  border-radius: 50%;
  background: ${({ active }) => (active ? MAIN_COLORS.yellow : MAIN_COLORS.purple_300)};
  transition: 0.25s;
`;
const Column =styled.div`
  display: flex;
  flex-direction: column;
  text-align: center;

  h1 {
    color: ${MAIN_COLORS.pink};
  }

  .yellow {
    color: ${MAIN_COLORS.yellow};
  }

  .gradient {
    background: ${MAIN_COLORS.gradient_yellow_pink};
    -webkit-background-clip: text;
    -webkit-text-fill-color: transparent;
  }
`

const slides = [
  {title:'Старт', text:'Собирай фигурки и открывай приключения', img: Mascot_hello},
  {title:'Коллекции', text:'Собирай коллекции из лутболов.Каждая хранит сюрпризы.', img: Mascot_ball},
  {title:'Баланс', text:'Пополняй баланс и крути лутболы. Просто и удобно через QR-код', img: Mascot_bank},
  {title:'Карта', text:'Ищи автоматы и секретные точки.Находи редкие призы.', img: Mascot_map},
  {title:'Рейтинг', text:'Соревнуйся с другими.Открывай достижения и побеждай.', img: Mascot_trrophy}
]

const Welcome:FC<IProps> = ({visible,close}) => {
  const [index, setIndex] = useState(0);

  const nextHandler = () => {
    if (index < slides.length - 1) {
      setIndex(index + 1);
      return;
    } 
    close();
  };

  const backHandler = () => {
    if (index) {
      setIndex(index - 1);
      return;
    } 
  };

  return (
    <Modal fullscreen={true} back={backHandler} isOpen={visible} close={close}>
      <MainWrapper>
        <Card>
          <Column className='main-header'>
            <h1 className='yellow'>добро пожаловать</h1>
            <h1 className='gradient'>В LOOTBALL</h1>
          </Column>

          <SliderWrapper>
            <SliderInner index={index}>
              <Rare/>
              {slides.map((item, i) => (
                <Slide key={i}>
                  <Lottie className='anim' animationData={item.img}/>
                  <Column className='header'>
                    <h1>{item.title}</h1>
                    <h2>{item.text}</h2>
                  </Column>
                </Slide>
              ))}
            </SliderInner>
          </SliderWrapper>
        </Card>

        <Indicators>
          {slides.map((_, i) => (
            <Dot key={i} active={i <= index} />
          ))}
        </Indicators>

        <MainButton onClick={nextHandler}>{index < slides.length - 1 ? 'Далее' : 'Начать'}</MainButton>
      </MainWrapper>
    </Modal>
  );
}

export default memo(Welcome)